<template>
  <div>
    <div v-if="loading" class="loading">
      <MoonLoader></MoonLoader>
    </div>
    <div v-else>
      <UpperSidebar :prop_categories="categories" summary-page-name="Resiliency Dashboard" />
      <div v-if="answers.length > 0" class="row">
        <div class="col-md-6 col-xl-3" v-for="answer in answers" :key="answer.id">
          <DashboardElementPrimary :answer="answer" :company="company"></DashboardElementPrimary>
        </div>
      </div>
      <div v-else class="row text-center">
        <div class="col">
          <h3>
            Here you will find your saved questions from the Questionnaire under the {{ category.name }} category.
            <br />
          </h3>
          <span class="text-font">
            To add them to the Dashboard go to
            <router-link
              :to="{
                path: '/manage_answers/' + company.company_id,
                query: {
                  company: company,
                  selectedQuestionType: question_type,
                  selectedFilters: [category],
                },
              }"
              >Questionnaire</router-link
            >
            and click on the button:
          </span>
          <br /><br />
          <p-button outline icon type="primary" class="questions-list__question-button">
            <i class="fas fa-star"></i>
          </p-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryController from '@/controllers/Category/CategoryController';
import UpperSidebar from '@/components/SidebarPlugin/UpperSidebar';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import CategoryDashboardElement from '@/controllers/Category/CategoryDashboardElement';
import GroupingController from '@/controllers/Helpers/GroupingController';
import DefineValueClass from '@/controllers/Class/DefineValueClass';
import DashboardElementPrimary from '@/components/Dashboard/DashboardElementPrimary';
import QuestionTypeController from '@/controllers/QuestionType/QuestionTypeController';

export default {
  name: 'Finance',
  components: { DashboardElementPrimary, MoonLoader, UpperSidebar },
  data() {
    return {
      categories: null,
      loading: false,
      answers: null,
      question_type: null,
    };
  },
  async created() {
    this.loading = true;
    this.categories = await this.getCategories();
    await this.setCategory();
    await this.getCategoryDashboardElements();
    await this.getCompany();
    this.question_type = await this.getQuestionType();
    this.loading = false;
  },
  methods: {
    async getCategories() {
      return await CategoryController.resiliencyCategories();
    },
    async setCategory() {
      this.category = this.categories.find((category) => {
        return category.name === 'finance';
      });
    },
    async getCategoryDashboardElements() {
      this.answers = await CategoryDashboardElement.show(this.category.id);
      if (this.$route.query.sortBy)
        this.answers = GroupingController.filterAnswers(this.answers, this.$route.query.sortBy);
      if (this.$route.query.find) this.answers = DefineValueClass.highlightAnswer(this.answers, this.$route.query.find);
    },
    async getCompany() {
      this.company = this.$store.getters.company;
    },
    async getQuestionType() {
      let questionTypes = await QuestionTypeController.index();
      let vm = this;
      return questionTypes.find(function (questionType) {
        return questionType.name === 'Resiliency';
      });
    },
  },
};
</script>

<style scoped></style>
